import { ApiError } from "@app/core/shared/data/network/errors/api.error";

export enum InfrastructureErrorType {
  ConnectionError = 0,
  InternalServerError = 1,
  TimeOutError = 2,
  BackendError = 3,
}

export class InfrastructureError extends Error {
  _type: InfrastructureErrorType;
  _error: any | null;
  apiError?: ApiError | undefined;
  constructor(
    _type: InfrastructureErrorType,
    _error: any | null,
    message?: string,
    apiError?: ApiError | undefined
  ) {
    super(message);
    this._type = _type;
    this._error = _error;
    this.apiError = apiError;
  }
  get type(): InfrastructureErrorType {
    return this._type;
  }
  get error(): any {
    return this._error;
  }
  get message(): string {
    return super.message;
  }
}
